import * as t from "io-ts";

export const ComponentValidations = t.exact(t.partial({
  required: t.union([t.boolean, t.string]),
  isAge: t.union([t.number, t.string]),
  under18Warning: t.union([t.boolean, t.string]),
  isEmail: t.union([t.boolean, t.string]),
  isDate: t.union([t.boolean, t.string]),
  isIBAN: t.union([t.boolean, t.string]),
  ibanStartsWith: t.union([t.array(t.string), t.string]),
}));
export type ComponentValidations = t.TypeOf<typeof ComponentValidations>;
